import React from 'react';

const LocationContext = React.createContext({});

export {
  LocationContext
};
